module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_c('strong', [_vm._v("Challenged…")])])]), _c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“Damn you, Hawk!” She swore at him to mask her disappointment and snatched the bra from the hook of his finger. He laughed, a throaty sound rich with amusement. She struck at him, but he caught her hand before it reached his face and pulled her against him. “Brute!” she hissed.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“And you are a tease,” he accused softly and silenced any reply with his mouth. Instantly there was a wild, hungry response to the domination of his kiss. The stiffness fled from her body; every curve welded itself to him.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Passion flamed hot and unchecked in both of them. Hawk let it burn, the heat flowing through his sensitized flesh. Yet there was no haste, no urgency in him. He would take her in his own good time and not be hurried by Carol as she was prone to do if he let her set the pace.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("His mind knew no guilt in taking her. In this, there was no confusion. For once, the practices of the Navaho and the white were in accord. Sex and the desire for it were natural things, as inevitable as life and death.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-417e2834","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 63
// module chunks = 0